
<template>
    <div class="modalBackground">
        <div class="ModalForm">
            <div class="header">
                <h1 class="Title">Manage Company/Role</h1>
                <div class="Options">

                    <button v-on:click.stop="save()">Save</button>
                    <button v-on:click.stop="cancel()">Cancel</button>
                </div>
            </div>
            <div class="modalBody" v-if="Loading">
                <p><loading-indicator /> Loading Role...</p>
            </div>
            <div class="modalBody" v-if="Saving">
                <p><loading-indicator /> Saving Role...</p>
            </div>
            <div class="modalBody" v-if="!Saving && !!Role && PGProviders !== null && BGProviders !== null && FactsheetProviders !== null && Logos !== null && ASIServices !== null && BGServices !== null && PGServices !== null">
                <!-- && Logos !== null">-->
                <br />
                <label>Company Name: <input :disabled="!canEditCompanyName" type="text" v-model="CompanyName" /></label>
                <br />
                <label>
                    Company Type:
                    <select v-model="Role.companyTypeId">
                        <option v-for="ctypes in companyTypes" :key="ctypes.id" :value="ctypes.id">{{ctypes.companyTypes}} </option>
                    </select>
                </label>
                <br />
                <label v-if="RoleName !== null">Role Name: <input type="text" v-model="RoleName" /></label>
                <label v-else>Role Name: <strong><i>All</i></strong></label>
                <br />
                <label>
                    Network support group: <select v-model="Role.network">
                        <option v-for="network of NetworkSupportGroups" :value="network" :key="network">{{ network }}</option>
                    </select>
                </label>
                <h2>Auto-Assignment</h2>
                <label>Assign to Product Provider with organisation name: <input v-model="Role.productProviderOrganisationNameToAutoAssign" /></label>
                <label>Assign to local and Unipass users in Firm with FCA No: <input type="text" v-model="Role.organisationFcanoToAutoAssign" /></label>
                <label>Assign to local and Unipass users in Network or Support Group: <input type="text" v-model="Role.supportNetworkToAutoAssign" /></label>
                <label>Assign to Unipass users with Firm ID: <input type="text" v-model="Role.unipassFirmIdtoAutoAssign" /></label>
                <label><input type="checkbox" v-model="Role.automaticallyGivenToUnipassAdvisers" />Assigned to new Unipass users registered with the FCA</label>
                <label><input type="checkbox" v-model="Role.automaticallyGivenToUnipassNonAdvisers" />Assigned to new Unipass Users not registered with the FCA</label>

                <h2>Benefits Guru Pro</h2>
                <label>Access to Benefits Guru Pro: <nullable-company-select v-model="Role.bgproAccess" /></label>
                <label v-if="Role.bgproAccess === true" title="leave blank for unlimited comparisons per month">Allowed Comparisons per Month: <nullable-integer-input v-model="Role.bgproComparisonsPerMonth" /> <i>(leave blank for unlimited comparisons per month)</i></label>
                <label v-if="Role.bgproAccess === true" title="leave blank for unlimited features">Allowed Features per Comparison: <nullable-integer-input v-model="Role.bgproFeatureLimit" /> <i>(leave blank for unlimited features)</i></label>
                <label v-if="Role.bgproAccess === true" title="leave blank for unlimited providers">Allowed Providers per Comparison: <nullable-integer-input v-model="Role.bgproProviderLimit" /> <i>(leave blank for unlimited providers)</i></label>
                <label v-if="Role.bgproAccess === true">Access to Benefits Guru Pro Advert Free: <nullable-company-select v-model="Role.bgproAdFreeAccess" /></label>
                <label v-if="Role.bgproAccess === true">Access to Non-Anonymised Version <nullable-company-select v-model="Role.bgproAccessToNonAnonymisedServices" /></label>
                <label v-if="Role.bgproAccess === true">Access to Copy Graphs In Benefits Guru Pro: <nullable-company-select v-model="Role.bgproAccessToCopyGraphs" /></label>
                <label v-if="Role.bgproAccess === true">Access to Benefits Guru Pro DataTables (outside of reports):<nullable-company-select v-model="Role.bgproDataTableAccess" /></label>
                <label v-if="Role.bgproAccess === true">Access to Benefits Guru Pro Report:<nullable-company-select v-model="Role.bgproReportAccess" /></label>
                <label v-if="Role.bgproAccess === true && Role.bgproReportAccess === true">Access to Benefits Guru Pro DataTables in Report: <nullable-company-select v-model="Role.bgproDataTableAccessInReport" /></label>
                <label v-if="Role.bgproAccess === true && Role.bgproReportAccess === true">Custom Styling of Report: <select v-model="BGReportCustomStyling"><option value="Yes">Yes</option><option value="No">No</option></select></label>
                <label v-if="Role.bgproAccess === true && Role.bgproReportAccess === true && BGReportCustomStyling == 'Yes'">Logo: <select v-model="Role.bgproReportLogo"><option v-for="logo in Logos" :key="logo.name" :value="logo.name">{{logo.name}}</option></select><button v-on:click.stop="addLogo()">Add Logo</button><br /><img style="max-width:100%" :src="Logos.filter(function(l) {return l.name === Role.pgproReportLogo;})[0].location" /></label>
                <label v-if="Role.bgproAccess === true && Role.bgproReportAccess === true && BGReportCustomStyling == 'Yes'">Primary Color: <input type="color" v-model="Role.bgproReportPrimaryColor" /></label>
                <label v-if="Role.bgproAccess === true && Role.bgproReportAccess === true && BGReportCustomStyling == 'Yes'">Secondary Color: <input type="color" v-model="Role.bgproReportSecondaryColor" /></label>
                <label v-if="Role.bgproAccess === true && Role.bgproReportAccess === true && BGReportCustomStyling == 'Yes'">Tertiary Color: <input type="color" v-model="Role.bgproReportTertiaryColor" /></label>
                <label v-if="Role.bgproAccess === true">Custom Benefits Guru Provider List: <select v-model="BGProCustomProviderList"><option value="No Change" title="The user's provider list is not altered by this role.">No Custom List</option><option value="All Providers" title="Users in this role will ALWAYS have access to all providers">All Providers</option><option title="Custom Provider List" value="Custom">Custom</option></select></label>
                <semicolon-list-control v-if="Role.bgproAccess === true && BGProCustomProviderList === 'Custom'" v-model="Role.bgproCustomProviderList" :list="BGProviders" />
                
                <label>Access to Dashboards: <nullable-company-select v-model="Role.bgproDashboardsAccess" /></label>

                <h2>Protection Guru Pro</h2>
                <label>Access to Protection Guru Pro: <nullable-company-select v-model="Role.pgproAccess" /></label>
                <label v-if="Role.pgproAccess === true" title="leave blank for unlimited comparisons per month">Allowed Comparisons per Month: <nullable-integer-input v-model="Role.pgproComparisonsPerMonth" /> <i>(leave blank for unlimited comparisons per month)</i></label>
                <label v-if="Role.pgproAccess === true" title="leave blank for unlimited features">Allowed Features per Comparison: <nullable-integer-input v-model="Role.pgproFeatureLimit" /> <i>(leave blank for unlimited features)</i></label>
                <label v-if="Role.pgproAccess === true" title="leave blank for unlimited providers">Allowed Providers per Comparison: <nullable-integer-input v-model="Role.pgproProviderLimit" /> <i>(leave blank for unlimited providers)</i></label>
                <label v-if="Role.pgproAccess === true">Access to Protection Guru Pro Advert Free: <nullable-company-select v-model="Role.pgproAdFreeAccess" /></label>
                <label v-if="Role.pgproAccess === true">Access to Protection Guru Pro Legacy Products:<nullable-company-select v-model="Role.pgproLegacyProductAccess" /></label>
                <label v-if="Role.pgproAccess === true">Access to Pricing: <nullable-company-select v-model="Role.pgproAccessToPricing" /></label>
                <label v-if="Role.pgproAccess === true && Role.pgproAccessToPricing === true">Access to Value: <nullable-company-select v-model="Role.pgproAccessToValue" /></label>
                <label v-if="Role.pgproAccess === true">Access to Copy Graphs In Protection Guru Pro: <nullable-company-select v-model="Role.pgproAccessToCopyGraphs" /></label>
                <label v-if="Role.pgproAccess === true">Access to Protection Guru Pro DataTables (outside of reports):<nullable-company-select v-model="Role.pgproDataTableAccess" /></label>
                <label v-if="Role.pgproAccess === true">Access to Protection Guru Pro Report:<nullable-company-select v-model="Role.pgproReportAccess" /></label>
                <label v-if="Role.pgproAccess === true && Role.pgproReportAccess === true">Access to Protection Guru Pro DataTables in Report: <nullable-company-select v-model="Role.pgproDataTableAccessInReport" /></label>
                <label v-if="Role.pgproAccess === true && Role.pgproReportAccess === true">Custom Styling of Report: <select v-model="PGReportCustomStyling"><option value="Yes">Yes</option><option value="No">No</option></select></label>
                <label v-if="Role.pgproAccess === true && Role.pgproReportAccess === true && PGReportCustomStyling == 'Yes'">Logo: <select v-model="Role.pgproReportLogo"><option v-for="logo in Logos" :key="logo.name" :value="logo.name">{{logo.name}}</option></select><button v-on:click.stop="addLogo()">Add Logo</button><br /><img style="max-width:100%" :src="Logos.filter(function(l) {return l.name === Role.pgproReportLogo;})[0].location" /></label>
                <label v-if="Role.pgproAccess === true && Role.pgproReportAccess === true && PGReportCustomStyling == 'Yes'">Primary Color: <input type="color" v-model="Role.pgproReportPrimaryColor" /></label>
                <label v-if="Role.pgproAccess === true && Role.pgproReportAccess === true && PGReportCustomStyling == 'Yes'">Secondary Color: <input type="color" v-model="Role.pgproReportSecondaryColor" /></label>
                <label v-if="Role.pgproAccess === true && Role.pgproReportAccess === true && PGReportCustomStyling == 'Yes'">Tertiary Color: <input type="color" v-model="Role.pgproReportTertiaryColor" /></label>
                <label v-if="Role.pgproAccess === true">Custom Protection Guru Provider List: <select v-model="PGProCustomProviderList"><option value="No Change" title="The user's provider list is not altered by this role.">No Custom List</option><option value="All Providers" title="Users in this role will ALWAYS have access to all providers">All Providers</option><option title="Custom Provider List" value="Custom">Custom</option></select></label>
                <semicolon-list-control v-if="Role.pgproAccess === true && PGProCustomProviderList === 'Custom'" v-model="Role.pgproCustomProviderList" :list="PGProviders" />
                <label v-if="Role.pgproAccess === true">Access to allow Global Templates:<nullable-company-select v-model="Role.pgProCanShareTemplate" /></label>
                <h2 v-if="Role.pgProCanShareTemplate === true">Global Templates</h2>
                <template v-if="Role.pgProCanShareTemplate === true">
                    <div>
                        <fieldset class="selectList" v-if="Templates !== null">
                            <table class="analysisStyles">
                                <thead>
                                    <tr>
                                        <th></th>
                                        <th>
                                            Template Name
                                        </th>
                                        <th>
                                            Date Created
                                        </th>
                                    </tr>
                                </thead>
                                <tbody v-if="Templates.length == 0">
                                    <tr>
                                        <td colspan="3">No Templates Found</td>
                                    </tr>
                                </tbody>
                                <tbody v-else>
                                    <tr v-for="template in Templates" :key="template.dataTableReference">
                                        <td>
                                            <input type="checkbox" v-bind:id="template.comparisonReference" @click="check($event, template)"
                                                   v-model="exTemplates" v-bind:value="template.comparisonReference" />
                                        </td>
                                        <td>{{template.templateName}}</td>
                                        <td>{{displayDate(template.createdOn)}}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </fieldset>
                    </div>
                </template>

                <!--Only visible when user click on manage not while creating the company -->
                <div v-if="Role.pgproAccess === true && roleId !== 'new'">
                    <pg-subscription v-model="Role.pgsubscription" :role-id="roleId" />
                </div>

                <h2>WordPress Sites</h2>
                <h3>Adviser Software Insights</h3>
                <label>Access to Adviser Software Insights Wordpress Site: <nullable-company-select v-model="Role.asiwordPressWebsiteAccess" /></label>
                <h4 v-if="Role.asiwordPressWebsiteAccess === true">Services</h4>
                <semicolon-list-control v-if="Role.asiwordPressWebsiteAccess === true" v-model="Role.asiservices" :list="ASIServices" />

                <h3>Benefits Guru</h3>
                <label>Access to Benefits Guru Wordpress Site: <nullable-company-select v-model="Role.bgwordPressWebsiteAccess" /></label>
                <label v-if="Role.bgwordPressWebsiteAccess === true">Access to Printing Benefit Guru Factsheets: <select v-model="BGPrintableProviderFactsheets"><option value="No Change" title="The user's access is not altered by this role.">Unaffected</option><option value="All Providers" title="Users in this role will have access to print all providers unless blocked by another role">All Providers</option><option title="Custom Provider List" value="Custom">Custom</option><option title="User will not have acces to print factsheets" value="Blocked">Blocked</option></select></label>
                <semicolon-list-control v-if="Role.bgwordPressWebsiteAccess === true && BGPrintableProviderFactsheets === 'Custom'" v-model="Role.bgprintableProviderFactsheets" :list="FactsheetProviders" />
                <h4 v-if="Role.bgwordPressWebsiteAccess === true">Services</h4>
                <semicolon-list-control v-if="Role.bgwordPressWebsiteAccess === true" v-model="Role.benefitsGuruServices" :list="BGServices" />

                <h3>Protection Guru</h3>
                <label>Access to Protection Guru Wordpress Site: <nullable-company-select v-model="Role.pgwordPressWebsiteAccess" /></label>
                <label v-if="Role.pgwordPressWebsiteAccess === true">Access to Printing Protection Guru Factsheets: <select v-model="PGPrintableProviderFactsheets"><option value="No Change" title="The user's access is not altered by this role.">Unaffected</option><option value="All Providers" title="Users in this role will have access to print all providers unless blocked by another role">All Providers</option><option title="Custom Provider List" value="Custom">Custom</option><option title="User will not have acces to print factsheets" value="Blocked">Blocked</option></select></label>
                <semicolon-list-control v-if="Role.pgwordPressWebsiteAccess === true && PGPrintableProviderFactsheets === 'Custom'" v-model="Role.pgprintableProviderFactsheets" :list="FactsheetProviders" />
                <h4 v-if="Role.pgwordPressWebsiteAccess === true">Services</h4>
                <semicolon-list-control v-if="Role.pgwordPressWebsiteAccess === true" v-model="Role.protectionGuruServices" :list="PGServices" />
                <br />
                <role-signatures :role-id="roleId" />
            </div>
        </div>
        <add-new-logo-dialog v-if="AddingNewLogo" @cancelled="AddingNewLogo = false" @logoadded="refreshLogos" />
    </div>
</template>

<script>
    import LoadingIndicator from './LoadingIndicator.vue';
    import NullableCompanySelect from './NullableCompanySelect.vue';
    import NullableIntegerInput from './NullableIntegerInput.vue';
    import SemicolonListControl from './SemicolonListControl.vue';
    import AddNewLogoDialog from './AddNewLogoDialog.vue';
    import PgSubscription from './PgSubscription.vue';
    import RoleSignatures from './RoleSignatures.vue';

    import $ from 'jquery';

    export default {
        name: 'CompanyRole',
        components: {
            LoadingIndicator,
            NullableCompanySelect,
            NullableIntegerInput,
            SemicolonListControl,
            AddNewLogoDialog,
            PgSubscription,
            RoleSignatures,
        },
        props: ["roleId", "canEditCompanyName", "InitialCompanyName"],
        data: function () {
            return {
                Role: null,
                Saving: false,
                BGProviders: null,
                PGProviders: null,
                FactsheetProviders: null,
                Logos: null,
                AddingNewLogo: false,
                ASIServices: null,
                PGServices: null,
                BGServices: null,
                Templates: null,
                checkedTemplates: [],
                exTemplates: [],
                NetworkSupportGroups: [],
                companyTypes: []
            }
        },
        computed: {
            "Loading": {
                get: function () {
                    return this.Role === null
                        || this.companyTypes === null
                        || this.PGProviders === null
                        || this.BGProviders === null
                        || this.FactsheetProviders === null
                        || this.Logos === null
                        || this.ASIServices === null
                        || this.BGServices === null
                        || this.PGServices === null
                        || this.NetworkSupportGroups === null;
                }
            },
            "CompanyName": {
                get: function () {
                    if (this.Role == null || this.Role.name == null)
                        return null;
                    return this.Role.name.split('~')[0];
                },
                set: function (value) {
                    if (this.RoleName == null)
                        this.Role.name = value;
                    else
                        this.Role.name = value + '~' + this.RoleName;
                }
            },
            "RoleName": {
                get: function () {
                    if (this.Role == null || this.Role.name == null || this.Role.name.split('~').length == 1)
                        return null;
                    else
                        return this.Role.name.split('~')[1];
                },
                set: function (value) {
                    this.Role.name = this.CompanyName + '~' + value;
                }
            },
            "BGProCustomProviderList": {
                "get": function () {
                    if (this.Role.bgproCustomProviderList === null)
                        return "No Change";
                    if (this.Role.bgproCustomProviderList === "ALL")
                        return "All Providers";
                    return "Custom";
                },
                "set": function (newValue) {
                    if (newValue === "No Change") {
                        this.Role.bgproCustomProviderList = null;
                    }
                    if (newValue === "All Providers") {
                        this.Role.bgproCustomProviderList = "ALL";
                    }
                    if (newValue === "Custom") {
                        if (this.Role.bgproCustomProviderList === "ALL" || this.Role.bgproCustomProviderList === null)
                            this.Role.bgproCustomProviderList = ""; //Show providers all unticked (maybe initially tick them?)
                    }
                }
            },
            "PGProCustomProviderList": {
                "get": function () {
                    if (this.Role.pgproCustomProviderList === null)
                        return "No Change";
                    if (this.Role.pgproCustomProviderList === "ALL")
                        return "All Providers";
                    return "Custom";
                },
                "set": function (newValue) {
                    if (newValue === "No Change") {
                        this.Role.pgproCustomProviderList = null;
                    }
                    if (newValue === "All Providers") {
                        this.Role.pgproCustomProviderList = "ALL";
                    }
                    if (newValue === "Custom") {
                        if (this.Role.pgproCustomProviderList === "ALL" || this.Role.pgproCustomProviderList === null)
                            this.Role.pgproCustomProviderList = ""; //Show providers all unticked (maybe initially tick them?)
                    }
                }
            },
            "PGReportCustomStyling": {
                "get": function () { return this.Role.pgproReportPrimaryColor === null ? "No" : "Yes" },
                "set": function (value) {
                    switch (value) {
                        case "No":
                            this.Role.pgproReportPrimaryColor = null;
                            this.Role.pgproReportSecondaryColor = null;
                            this.Role.pgproReportTertiaryColor = null;
                            this.Role.pgproReportLogo = null;
                            break;
                        case "Yes":
                            this.Role.pgproReportPrimaryColor = "#1e228c";
                            this.Role.pgproReportSecondaryColor = "#f8c212";
                            this.Role.pgproReportTertiaryColor = "#1e228c";
                            this.Role.pgproReportLogo = this.Logos[0].name;
                            break;
                    }
                }
            },
            "BGReportCustomStyling": {
                "get": function () { return this.Role.bgproReportPrimaryColor === null ? "No" : "Yes" },
                "set": function (value) {
                    switch (value) {
                        case "No":
                            this.Role.bgproReportPrimaryColor = null;
                            this.Role.bgproReportSecondaryColor = null;
                            this.Role.bgproReportTertiaryColor = null;
                            this.Role.bgproReportLogo = null;
                            break;
                        case "Yes":
                            this.Role.bgproReportPrimaryColor = "#9325b2";
                            this.Role.bgproReportSecondaryColor = "#b2b3b7";
                            this.Role.bgproReportTertiaryColor = "#000000";
                            this.Role.bgproReportLogo = this.Logos[0].name;
                            break;
                    }
                }
            },
            "BGPrintableProviderFactsheets": {
                "get": function () {
                    if (this.Role.bgprintableProviderFactsheets === null)
                        return "No Change";
                    if (this.Role.bgprintableProviderFactsheets === "ALL")
                        return "All Providers";
                    if (this.Role.bgprintableProviderFactsheets === "BLOCKED")
                        return "Blocked";
                    return "Custom";
                },
                "set": function (newValue) {
                    if (newValue === "No Change") {
                        this.Role.bgprintableProviderFactsheets = null;
                    }
                    if (newValue === "All Providers") {
                        this.Role.bgprintableProviderFactsheets = "ALL";
                    }
                    if (newValue === "Blocked") {
                        this.Role.bgprintableProviderFactsheets = "BLOCKED";
                    }
                    if (newValue === "Custom") {
                        if (this.Role.bgprintableProviderFactsheets === "ALL" || this.Role.bgprintableProviderFactsheets === null || this.Role.bgprintableProviderFactsheets === "BLOCKED")
                            this.Role.bgprintableProviderFactsheets = ""; //Show providers all unticked (maybe initially tick them?)
                    }
                }
            },
            "PGPrintableProviderFactsheets": {
                "get": function () {
                    if (this.Role.pgprintableProviderFactsheets === null)
                        return "No Change";
                    if (this.Role.pgprintableProviderFactsheets === "ALL")
                        return "All Providers";
                    if (this.Role.pgprintableProviderFactsheets === "BLOCKED")
                        return "Blocked";
                    return "Custom";
                },
                "set": function (newValue) {
                    if (newValue === "No Change") {
                        this.Role.pgprintableProviderFactsheets = null;
                    }
                    if (newValue === "All Providers") {
                        this.Role.pgprintableProviderFactsheets = "ALL";
                    }
                    if (newValue === "Blocked") {
                        this.Role.pgprintableProviderFactsheets = "BLOCKED";
                    }
                    if (newValue === "Custom") {
                        if (this.Role.pgprintableProviderFactsheets === "ALL" || this.Role.pgprintableProviderFactsheets === null || this.Role.pgprintableProviderFactsheets === "BLOCKED")
                            this.Role.pgprintableProviderFactsheets = ""; //Show providers all unticked (maybe initially tick them?)
                    }
                }
            }
        },
        created: function () {
            var myComponent = this;
            $.ajax({
                type: 'GET',
                url: 'Logos',
                dataType: 'json',
                success: function (data) {
                    myComponent.Logos = data;
                }
            });
            $.ajax({
                type: 'GET',
                url: 'Roles/' + this.roleId,
                dataType: 'json',
                success: function (data) {
                    if (myComponent.InitialCompanyName !== null)
                        data.name = myComponent.InitialCompanyName;
                    myComponent.Role = data;
                }
            });
            $.ajax({
                type: 'GET',
                url: 'Providers/PG',
                dataType: 'json',
                success: function (data) {
                    myComponent.PGProviders = data;
                }
            });
            $.ajax({
                type: 'GET',
                url: 'Providers/BG',
                dataType: 'json',
                success: function (data) {
                    myComponent.BGProviders = data;
                }
            });
            $.ajax({
                type: 'GET',
                url: 'Providers/Factsheets',
                dataType: 'json',
                success: function (data) {
                    myComponent.FactsheetProviders = data;
                }
            });
            $.ajax({
                type: 'GET',
                url: 'Settings/ASIServices',
                dataType: 'json',
                success: function (data) {
                    myComponent.ASIServices = data.map(function (s) { return { value: s.wordpressServiceName, display: s.wordpressServiceName }; });
                }
            });
            $.ajax({
                type: 'GET',
                url: 'Settings/ProtectionGuruServices',
                dataType: 'json',
                success: function (data) {
                    myComponent.PGServices = data.map(function (s) { return { value: s.wordpressServiceName, display: s.wordpressServiceName }; });
                }
            });
            $.ajax({
                type: 'GET',
                url: 'Settings/NetworkSupportGroup',
                dataType: 'json',
                success: function (data) {
                    data.forEach((item) => {
                        myComponent.NetworkSupportGroups.push(item.name);
                    })
                }
            });
            $.ajax({
                type: 'GET',
                url: 'Settings/BenefitsGuruServices',
                dataType: 'json',
                success: function (data) {
                    myComponent.BGServices = data.map(function (s) { return { value: s.wordpressServiceName, display: s.wordpressServiceName }; });
                }
            });
            $.ajax({
                type: 'GET',
                url: 'Roles/LifePro/true',
                contentType: 'application/json',
                success: function (GTemplates) {
                    myComponent.Templates = GTemplates;

                    $.ajax({
                        type: 'GET',
                        url: 'Roles/' + myComponent.roleId + '/true/true',
                        contentType: 'application/json',
                        success: function (data) {
                            myComponent.exTemplates = data;
                            myComponent.Templates.forEach(function (template) {
                                if (myComponent.exTemplates.includes(template.comparisonReference))
                                    myComponent.checkedTemplates.push(template);
                            });
                        },
                        error: function (xhr) {
                            if (xhr.status == 401) {
                                window.location = "./Api/signin";
                                return;
                            }
                        }
                    });
                },
                error: function (xhr) {
                    if (xhr.status == 401) {
                        window.location = "./Api/signin";
                        return;
                    }
                }
            });
            $.ajax({
                type: 'GET',
                url: '/Roles/GetCompanyType',
                dataType: 'json',
                success: function (data) {
                    myComponent.companyTypes = data;
                }
            });            
        },
        methods: {
            "cancel": function () {
                this.$emit('update:roleId', null);
            },
            "save": function () {
                var thisControl = this;
                if (this.CompanyName.trim() === "") {
                    alert("You must supply a name for the company.");
                    return;
                }
                if (this.RoleName !== null && this.RoleName.trim() == "") {
                    alert("You must supply a name for this role.")
                    return;
                }
                this.Saving = true;
                $.ajax({
                    type: 'POST',
                    url: "/Roles",
                    contentType: 'application/json',
                    data: JSON.stringify({
                        role: thisControl.Role,
                        sharedTemplates: thisControl.checkedTemplates
                    }),
                    success: function () {
                        thisControl.Saving = false;
                        thisControl.$emit('update:roleId', null);
                    },
                    error: function (xhr) {
                        thisControl.Saving = false;
                        alert("Error saving:" + xhr.responseText);
                    }
                });

            },
            "addLogo": function () {
                this.AddingNewLogo = true;
            },
            "refreshLogos": function () {
                var myComponent = this;
                myComponent.Logos = null;
                $.ajax({
                    type: 'GET',
                    url: 'Logos',
                    dataType: 'json',
                    success: function (data) {
                        myComponent.Logos = data;
                    }
                });
                this.AddingNewLogo = false;
            },
            "displayDate": function (d) {
                if (d === null || d === "")
                    return "-";
                return d.substr(8, 2) + "/" + d.substr(5, 2) + "/" + d.substr(0, 4);
            },
            "check": function (e, template) {
                var myComponent = this;
                if (e.target.checked) {
                    myComponent.checkedTemplates.push(template);
                }
                else {
                    const index = myComponent.checkedTemplates.indexOf(template);
                    if (index > -1) {
                        myComponent.checkedTemplates.splice(index, 1)
                    }
                }
            },
        },
    }
</script>